"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicWidgetsService = void 0;
var widgets_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/widgets/widgets");
var to_error_1 = require("../../parsers/to-error");
var hosts_1 = require("@wix/wix-vod-constants/dist/env/hosts");
var object_1 = require("@wix/wix-vod-shared/dist/src/common/utils/object");
var PublicWidgetsService = /** @class */ (function () {
    function PublicWidgetsService(httpClient) {
        var _this = this;
        this.getWidgetSettings = function (widgetId) {
            return _this.publicWidgets
                .getSettings(widgetId)
                .then(function (response) { return (0, object_1.keysToCamelCase)(response.data); })
                .catch(to_error_1.toError);
        };
        this.getWidgetSettingsByInstanceId = function (instanceId) {
            return _this.publicWidgets
                .getSettingsByInstanceId(instanceId)
                .then(function (response) {
                return (0, object_1.keysToCamelCase)(response.data);
            })
                .catch(to_error_1.toError);
        };
        this.buildVideoCardsDeeplinkUrl = function (_a) {
            var channelId = _a.channelId, videoId = _a.videoId, fallbackUrl = _a.fallbackUrl, instance = _a.instance;
            return _this.publicWidgets.buildVideoCardsDeeplinkUrl({
                host: hosts_1.PRODUCTION_HOSTS.catalog,
                channelId: channelId,
                videoId: videoId,
                fallbackUrl: fallbackUrl,
                instance: instance,
            });
        };
        this.buildChannelCardsDeeplinkUrl = function (_a) {
            var channelId = _a.channelId, fallbackUrl = _a.fallbackUrl, instance = _a.instance;
            return _this.publicWidgets.buildChannelCardsDeeplinkUrl({
                host: hosts_1.PRODUCTION_HOSTS.catalog,
                channelId: channelId,
                fallbackUrl: fallbackUrl,
                instance: instance,
            });
        };
        this.publicWidgets = new widgets_1.PublicWidgets(httpClient);
    }
    return PublicWidgetsService;
}());
exports.PublicWidgetsService = PublicWidgetsService;
//# sourceMappingURL=widgets.js.map